import "./index.scss";

/**
 * Shown for the moment it takes to download a game or page the first time it
 * opens (games and rarely-used pages load on demand; see GameContainer and
 * AppRouter).
 *
 * @returns {JSX.Element}
 */
const LazyFallback = () => (
  <div className="lazyfallback_container" role="status" aria-live="polite">
    <p className="lazyfallback_text">Loading...</p>
  </div>
);

export default LazyFallback;
